import Confetti from "@/components/ui/confetti";
import { Credenza, CredenzaContent } from "@/components/ui/credenza";
import { useState } from "react";
import { ClaimDialogContent } from "./content";

export function ClaimDialog({
    claims,
    onClaimsChange,
}: {
    claims: { type: "campaign" | "youtube"; id: string }[] | undefined;
    onClaimsChange: (claims?: { type: "campaign" | "youtube"; id: string }[]) => void;
}) {
    const [isConfettiActive, setIsConfettiActive] = useState(false);

    return (
        <>
            <Credenza
                open={claims != null && claims.length > 0}
                onOpenChange={(v) => {
                    if (!v) onClaimsChange(undefined);
                }}
            >
                <CredenzaContent>
                    {claims != null && (
                        <ClaimDialogContent
                            claims={claims}
                            onSuccess={() => {
                                setIsConfettiActive(true);
                                setTimeout(() => {
                                    setIsConfettiActive(false);
                                }, 5000);
                            }}
                        />
                    )}
                </CredenzaContent>
            </Credenza>
            {isConfettiActive && <Confetti isActive={true} duration={5000} />}
        </>
    );
}
